<div #pinRolesButton
     class="d-flex-inline">
    <button adaptButtonIcon="fal fa-user-circle-plus"
            class="btn btn-link btn-sm"
            [disabled]="popupVisible"
            adaptTooltip="This allows people who are not members of the group to appear under the roles.<br>This does not grant the person any additional access to the group."
            [adaptTooltipIsHtml]="true"
            (click)="popupVisible = true">Add external person to {{team.name}} roles</button>
    <dx-popover [target]="pinRolesButton"
                [visible]="popupVisible"
                [hideOnOutsideClick]="false"
                height="auto"
                maxHeight="70vh"
                width="330px">
        <div *dxTemplate="let data = model of 'content'"
             class="d-flex flex-column gap-2">
            <adapt-select-people [people]="selectedPeople"
                                 (peopleChange)="onPeopleChange($event)"
                                 [filter]="teamPersonFilter"
                                 data-test="select-people"></adapt-select-people>

            <div class="d-flex flex-row justify-content-evenly">
                <button adaptButtonIcon="fal fa-user-circle-plus"
                        class="btn btn-sm btn-primary flex-fill"
                        [disabled]="selectedPeople.length === 0"
                        [adaptBlockingClick]="onAddClicked"
                        [unsubscribeOnDestroy]="false"
                        data-test="pin-people-button">Add external person</button>
                <button adaptButton="cancel"
                        class="btn-sm flex-fill"
                        [disabled]="saving"
                        (click)="cancel()"></button>
            </div>
        </div>
    </dx-popover>
</div>
